import React from 'react';
import { Star, BadgeCheck } from 'lucide-react';
const testimonials = [{
  name: 'Carlos M.',
  business: 'Barbería Tradición',
  text: 'Pasé de no aparecer en Google a tener 5 citas nuevas por semana. La gente me dice que la página se ve súper profesional. La mejor inversión que he hecho.',
  image: 'https://i.pravatar.cc/150?img=11'
}, {
  name: 'Laura V.',
  business: 'Estudio de Uñas',
  text: 'Antes solo dependía de Instagram y era muy inestable. Ahora mis clientas reservan directo por WhatsApp desde la web. El diseño quedó hermoso.',
  image: 'https://i.pravatar.cc/150?img=5'
}, {
  name: 'Dr. Roberto S.',
  business: 'Fisioterapia Integral',
  text: 'No sabía nada de tecnología, pero el equipo de Krove hizo todo súper fácil. En 5 días ya tenía mi página lista y optimizada. Excelente servicio.',
  image: 'https://i.pravatar.cc/150?img=8'
}];
export function Testimonials() {
  return <section className="py-24 px-6 bg-background relative" data-id="element-279">
      <div className="max-w-7xl mx-auto" data-id="element-280">
        <div className="text-center mb-16" data-id="element-281">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-282">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-283">
            Resultados reales para negocios reales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-284">
          {testimonials.map((testimonial, index) => <div key={index} className="glass-panel p-8 rounded-3xl relative" data-id="element-285">
              <div className="flex gap-1 mb-6" data-id="element-286">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent-start text-accent-start" data-id="element-287" />)}
              </div>

              <p className="text-white text-lg leading-relaxed mb-8 font-light italic" data-id="element-288">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-289">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white/10" data-id="element-290" />
                <div data-id="element-291">
                  <h4 className="text-white font-medium flex items-center gap-1.5" data-id="element-292">
                    {testimonial.name}
                    <BadgeCheck className="w-4 h-4 text-blue-400" data-id="element-293" />
                  </h4>
                  <p className="text-sm text-text-secondary" data-id="element-294">
                    {testimonial.business}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}